import { ExemptionStatus, ExemptionType } from './constants';

export const getExemptionType = (typeId) =>
  Object.values(ExemptionType).find((type) => type.value === typeId)?.longLabel;

export const getExemptionStatus = (statusId) =>
  Object.values(ExemptionStatus).find((status) => status.value === statusId);
